export default __webpack_public_path__ + "static/media/lADPGoU8dHd4J1PNBQDNA8A_960_1280.6bd10050.jpeg";